import { render, staticRenderFns } from "./pessoas.vue?vue&type=template&id=fa05fac8&"
import script from "./pessoas.vue?vue&type=script&lang=js&"
export * from "./pessoas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports